import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import {QueryParamsService} from '../../core/services/query-params.service';
import {plainToClass, plainToClassFromExist} from 'class-transformer';
import {QueryParamsApiModel} from '../models/query-params-api.model';
import {ResultListApiModel} from '../models/result-list.api.model';
import {ReactionApiModel} from '../models/reaction.api.model';

@Injectable({
  providedIn: 'root'
})
export class ReactionRestService {
  private readonly resource: string = '/reactions';

  constructor(
    private http: HttpClient,
    public params: QueryParamsService
  ) {
  }

  public create(reactionAM: ReactionApiModel, options?: {headers?: HttpHeaders}): Observable<ReactionApiModel> {
    return this.http.post<ReactionApiModel>(environment.apiUrl + this.resource, reactionAM, options)
      .pipe(map((result: ReactionApiModel) => plainToClass(ReactionApiModel, result)));
  }

  public put(reactionAM: ReactionApiModel): Observable<ReactionApiModel> {
    return this.http.put<ReactionApiModel>(environment.apiUrl + reactionAM['@id'], reactionAM)
      .pipe(map((result: ReactionApiModel) => plainToClass(ReactionApiModel, result)));
  }

  public get(reactionAM: ReactionApiModel): Observable<ReactionApiModel> {
    return this.http.get<ReactionApiModel>(environment.apiUrl + reactionAM['@id'])
      .pipe(map((result: ReactionApiModel) => plainToClass(ReactionApiModel, result)));
  }

  public delete(reactionAM: ReactionApiModel, options?: {headers?: HttpHeaders}): Observable<HttpResponse<object>> {
    return this.http.delete<HttpResponse<object>>(environment.apiUrl + reactionAM['@id'], options);
  }

  public getCollection(queryParamsApiModel: QueryParamsApiModel = new QueryParamsApiModel()): Observable<ResultListApiModel<ReactionApiModel>> {
    const params = this.params.applyParameters(queryParamsApiModel);
    return this.http.get<ResultListApiModel<ReactionApiModel>>(environment.apiUrl + this.resource, {params})
      .pipe(map(result => plainToClassFromExist(new ResultListApiModel<ReactionApiModel>(ReactionApiModel), result as object)));
  }
}
